module.exports = __webpack_public_path__ + "static/media/bg-signup.6207c920.png";